module.exports = __webpack_public_path__ + "assets/01a68cca6394bb55312ae1d723285d73.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-latin-ext-700-normal.woff2
// module id = 2641
// module chunks = 121